import React from 'react'
// import BgImage from "../images/acfan.jpg";
import { Link } from 'react-router-dom';
import Myservice from '../Myservice';


function OurServices() {
  return (
    <div className='pt-5'>
             <div
      style={{
        backgroundImage: `url(https://swastikengineers.net/static/media/acfan.ffd0da379b93a2b40ba6.jpg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        width: "100%",
        minHeight: "250px", // mobile friendly chhota height
        paddingTop: "50px", // desktop: 50px, mobile: 30px
        paddingBottom: "30px",
        position: "relative",
        color: "white",
      }}
      className="d-flex align-items-center"
    >
      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 1,
        }}
        className="overlay"
      ></div>

      {/* Content */}
      <div
        style={{
          position: "relative",
          zIndex: 2,
          maxWidth: "1200px",
          margin: "0 auto",
          textAlign: "center",
          padding: "0 15px",
        }}
        className="container-fluid p-3"
      >
        <h1
          className="fw-bold"
          style={{ fontSize: "clamp(1.8rem, 5vw, 2rem)", fontWeight: "700", color: "white" }}
        >
          Our Services
        </h1>
        <p
          className="lead"
          style={{
            fontSize: "clamp(1.2rem, 2.5vw, 1rem)",
            margin: "0.5rem 0 1rem 0",
            color: "whitesmoke",
          }}
        >
          PSF Academy (Palanhaar sanatan foundation) is an institution dedicated to promoting the principles of Sanatan Dharma, Indian culture, and moral values.
It aims to guide youth and children towards the right path by connecting them with spirituality, ethics, and the true essence of life.
        </p>

        {/* Breadcrumbs */}
        <nav aria-label="breadcrumb">
          <ol
            style={{
              listStyle: "none",
              display: "flex",
              justifyContent: "center",
              padding: 0,
              margin: 0,
            }}
          >
            <li style={{ marginRight: "5px" }}>
              <Link to="/" style={{ color: "white", textDecoration: "none" }}>
                Home
              </Link>
              <span style={{ margin: "0 5px" }}>/</span>
            </li>
            <li style={{ color: "white" }}>Our Installations</li>
          </ol>
        </nav>
      </div>
    </div>
      <Myservice />
    </div>
  )
}

export default OurServices
